export default "__VITE_ASSET__iw7Eawk5__"